import { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ensureBotConfigForRoute } from '../config/getBotConfig';
import { setCurrentConfig } from '../config/currentBotConfig';
import { BotConfigProvider, useBotConfig } from '../context/BotConfigContext';
import useAuthService from '../services/auth/authService';
import useLayoutService from '../services/layout/layoutService';
import applyTheme from '../theme/applyTheme';
import Chat from './chat/Chat';
import classes from './App.module.css';

function BotPageContent() {
  const authService = useAuthService();
  const authState = useSelector((state) => state.auth);
  const config = useBotConfig();

  useLayoutService();

  useEffect(() => {
    authService.auth();
  }, []);

  useEffect(() => {
    if (authState.isAuth || window.config?.autoLogin !== true) return;
    authService.accessRequest();
  }, [authState.isAuth]);

  if (authState.isAuth) {
    return <Chat />;
  }

  return (
    <div className={classes.Cookies}>
      <div className={classes.CookiesText}>{config?.nonAuthText}</div>
      <button className={classes.CookiesButton} onClick={() => authService.accessRequest()}>
        {"למתן הרשאה"}
      </button>
    </div>
  );
}

function ApplyThemeAndContent() {
  const config = useBotConfig();
  useEffect(() => {
    if (config?.theme) applyTheme(config.theme);
  }, [config?.theme]);
  return (
    <div className={classes.App}>
      <BotPageContent />
    </div>
  );
}

export default function BotPage() {
  const { domainName, botName } = useParams();
  const [configWithUrl, setConfigWithUrl] = useState(null);
  const [loadFailed, setLoadFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoadFailed(false);
    setConfigWithUrl(null);

    ensureBotConfigForRoute(domainName, botName)
      .then((config) => {
        if (cancelled) return;
        if (!config) {
          setLoadFailed(true);
          return;
        }
        const pathname = window.location.pathname.replace(/\/$/, '') || '/';
        const next = {
          ...config,
          botUrl: window.location.origin + (pathname === '/' ? '' : pathname)
        };
        setCurrentConfig(next);
        setConfigWithUrl(next);
      })
      .catch(() => {
        if (!cancelled) setLoadFailed(true);
      });

    return () => {
      cancelled = true;
    };
  }, [domainName, botName]);

  if (!configWithUrl && !loadFailed) {
    return null;
  }

  if (loadFailed || !configWithUrl) {
    return <Navigate to="/" replace />;
  }

  return (
    <BotConfigProvider value={configWithUrl}>
      <ApplyThemeAndContent />
    </BotConfigProvider>
  );
}